import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import beneficiario from "./beneficiario";
import portal from "./portal";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    beneficiario,
    portal
  },
  plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== "production"
});
